import { CurrencyPipe } from '@angular/common';
import { Component, computed, inject, input } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { isString } from 'lodash';
import { derivedAsync } from 'ngxtension/derived-async';
import { filter, map, of, shareReplay, switchMap } from 'rxjs';
import { ChatPaymentsService } from 'src/shared/services/chat-payments/chat-payments.service';
import { ChatStatus } from 'src/shared/stores/chat/chat-data.store';
import { ChatFacade } from 'src/shared/stores/chat/chat-facade.store';
import { bookingexternal } from 'src/shared/services/client/client';

@Component({
  selector: 'app-chat-window-payment',
  standalone: true,
  providers: [CurrencyPipe],
  templateUrl: './chat-window-payment.component.html',
  styleUrl: './chat-window-payment.component.scss',
})
export class ChatWindowPaymentComponent {
  chatStore = inject(ChatFacade);
  paymentService = inject(ChatPaymentsService);
  currencyPipe = inject(CurrencyPipe);
  chatStatus = ChatStatus;
  currentChat = input.required<bookingexternal.GetChatResponse | undefined>();
  chatService = toObservable(this.chatStore.data.chatServiceDocId).pipe(
    filter((docId) => isString(docId) && docId.length > 0),
    shareReplay(1)
  );
  price = derivedAsync(() => {
    return of(this.currentChat()).pipe(
      switchMap((chat) =>
        this.chatService.pipe(
          map((chatServiceDocId) => {
            return { chat, chatServiceDocId };
          })
        )
      ),
      switchMap(({ chat, chatServiceDocId }) => {
        if (!chatServiceDocId || !chat) {
          return of(undefined);
        }
        return this.paymentService.getChatServicePrice(chatServiceDocId).pipe(
          map((priceInfo) => {
            if (priceInfo) {
              return {
                price: priceInfo.price,
                currency: priceInfo.currency,
              };
            }
            return undefined;
          })
        );
      })
    );
  });
  priceLabel = computed(() => {
    const price = this.price();
    if (price) {
      return `Pay ${this.currencyPipe.transform(price.price / 100, price.currency)}`;
    }
    return 'Pay for chat';
  });
}
